import React, { useEffect } from 'react';
import GradientBackground from '@/components/landing/okx/GradientBackground';
import Footer from '@/components/landing/okx/Footer';
import HeroSection from '@/components/landing/okx/HeroSection';
import StepsSection from '@/components/landing/okx/StepsSection';
import StatsSection from '@/components/landing/okx/StatsSection';
import FeaturesSection from '@/components/landing/okx/FeaturesSection';
import LanguageSelector from '@/components/landing/okx/LanguageSelector';
import WhyMetradeSection from '@/components/landing/okx/WhyMetradeSection';
import StrategyShowcaseSection from '@/components/landing/okx/StrategyShowcaseSection';
import TestimonialsSection from '@/components/landing/okx/TestimonialsSection';
import FaqSection from '@/components/landing/okx/FaqSection';
import CallToActionSection from '@/components/landing/okx/CallToActionSection';
import { useReferralUrlParams } from '@/hooks/referrals/useReferralUrlParams';
import { useOkxCampaign } from '@/hooks/referrals/useOkxCampaign';
import { LangProvider } from '@/contexts/LangContext';
import { motion } from 'framer-motion';
import MetaTags from '@/components/meta/MetaTags';

const OkxLanding = () => {
  useReferralUrlParams();
  useOkxCampaign();
  
  // Add effect to trigger language initialization
  useEffect(() => {
    const savedLang = localStorage.getItem('okx_prefLang');
    console.log('Initial OKX language:', savedLang || 'en');
  }, []);
  
  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        duration: 0.6,
      }
    }
  };
  
  useEffect(() => {
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <LangProvider>
      <MetaTags 
        customTitle="OKX + METRADE | Professional Trading Strategies"
        customDescription="Access professional trading strategies with METRADE and OKX. Trade smarter with verified strategies and expert support."
        customImage="/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png"
        customUrl="https://metrade.io/landing/okx"
      />
      
      <div className="relative min-h-screen w-full bg-black text-white overflow-x-hidden">
        <GradientBackground />
        <LanguageSelector />
        <motion.div 
          className="relative pt-24 pb-12 px-4 flex flex-col items-center justify-center"
          initial="hidden"
          animate="visible"
          variants={sectionVariants}
        >
          <HeroSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <WhyMetradeSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <StepsSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <StatsSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <StrategyShowcaseSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <FeaturesSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <TestimonialsSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <FaqSection />
        </motion.div>
        <motion.div 
          className="relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={sectionVariants}
        >
          <CallToActionSection />
        </motion.div>
        <div className="relative z-10">
          <Footer />
        </div>
      </div>
    </LangProvider>
  );
};

export default OkxLanding;
